import { inject } from "@angular/core";
import { AuthenticationService } from "@app/core/services/authentication.service";
import { RouteService } from "@app/core/services/route.service";
import { ROUTES } from "@app/shared/constants/routes.constants";

export const ViewContractsGuard = () => {
  const authService = inject(AuthenticationService);
  const routeService = inject(RouteService);

  if (!authService.isAuthenticated()) {
    routeService.navigate([ROUTES.LOGIN]);
    return false;
  }

  if (!authService.isContracts() || authService.isHouseAccount) {
    routeService.navigateHome();
    return false;
  }

  return true;
};
